import type { FC } from 'react';
import { Flex, Statistic } from '@ui';
import { useTranslation } from 'react-i18next';
import { useRegion } from '@/queries/useRegion';

export const RegionMetrics: FC = () => {
    const { data: region } = useRegion();
    const { t } = useTranslation();

    return (
        <Flex flex="0 0 50%" justify="space-evenly">
            <Statistic
                title={t('Stats_ATC')}
                value={region.atc_active}
            />
            <Statistic
                title={t('Stats_Aircraft')}
                value={region.traffic}
            />
        </Flex>
    );
};
